import type { NavigateFunction } from 'react-router-dom';
import type { MouseEvent as ReactMouseEvent } from 'react';

export function toAbsoluteAppUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${window.location.origin}${normalized}`;
}

export function openAppPathInNewTab(path: string): void {
  window.open(toAbsoluteAppUrl(path), '_blank', 'noopener,noreferrer');
}

export type ModifierAwareNavigateOptions = {
  afterSameTabNavigate?: () => void;
};

export function handleModifierAwareNavigate(
  e: ReactMouseEvent,
  navigate: NavigateFunction,
  to: string,
  options?: ModifierAwareNavigateOptions
): void {
  if (e.defaultPrevented) {
    return;
  }

  if (e.type === 'auxclick') {
    if (e.button === 1) {
      e.preventDefault();
      openAppPathInNewTab(to);
    }
    return;
  }

  if (e.type === 'click') {
    if (e.button !== 0) {
      return;
    }
    if (e.metaKey || e.ctrlKey) {
      e.preventDefault();
      openAppPathInNewTab(to);
      return;
    }
    navigate(to);
    options?.afterSameTabNavigate?.();
  }
}

export function navigationClickHandlers(
  navigate: NavigateFunction,
  to: string,
  options?: ModifierAwareNavigateOptions
): {
  onClick: (e: ReactMouseEvent) => void;
  onAuxClick: (e: ReactMouseEvent) => void;
} {
  const run = (e: ReactMouseEvent): void => {
    handleModifierAwareNavigate(e, navigate, to, options);
  };
  return { onClick: run, onAuxClick: run };
}
